import { DateFormatOptions, ScheduleChangeMode } from '@griply/types';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { format, isSameYear } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogVariantOptions } from 'shared/assets/styles';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { useToday } from 'shared/contexts/today';

import * as Styled from './habit-schedule-confirm-changes-dialog.style';

export type HabitScheduleConfirmChangesDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (mode: ScheduleChangeMode) => void;
  startDate: Date;
  dateFormat?: DateFormatOptions;
};

export const HabitScheduleConfirmChangesDialog: React.FC<
  HabitScheduleConfirmChangesDialogProps
> = ({ open, onClose, onConfirm, startDate }) => {
  const { t } = useTranslation();
  const today = useToday();
  const dateFormatted = isSameYear(startDate, today)
    ? format(startDate, 'MMM d')
    : format(startDate, "MMM d ''yy");

  const handleConfirmToday = () => onConfirm(ScheduleChangeMode.Today);
  const handleConfirmOriginal = () => onConfirm(ScheduleChangeMode.Original);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      variant={DialogVariantOptions.ExtraSmall}
    >
      <Styled.Container>
        <Styled.Header>
          <Typography variant="h5" component="h1">
            {t('dialogs.habit-schedule.confirm-changes.title')}
          </Typography>
        </Styled.Header>

        <Styled.Footer>
          <Button
            variant={Variants.Contained}
            size={Sizes.Medium}
            color={Colors.TextPrimary}
            fullWidth
            onClick={handleConfirmToday}
            alignCenter
          >
            {t('dialogs.habit-schedule.confirm-changes.option.from-today')}
          </Button>

          <Button
            variant={Variants.Contained}
            size={Sizes.Medium}
            color={Colors.TextPrimary}
            onClick={handleConfirmOriginal}
            fullWidth
            alignCenter
          >
            {t('dialogs.habit-schedule.confirm-changes.option.from-start', {
              date: dateFormatted,
            })}
          </Button>
        </Styled.Footer>
      </Styled.Container>
    </Dialog>
  );
};
